var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"text-center py-4"},[_c('b-spinner',{attrs:{"variant":"primary"}})],1):_c('div',{staticClass:"text-center py-2 text-muted"},[_vm._v(" "+_vm._s(_vm.$t('No data for table'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }